module.exports = __webpack_public_path__ + "img/ic_close_white.c63f1e43.svg";